
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.66968 21.9979C4.51268 21.9979 4.35669 21.9503 4.22443 21.8498C3.9912 21.67 3.87459 21.3685 3.92305 21.0723L5.06495 14.0958L0.228789 9.16094C0.0223178 8.94937 -0.0518905 8.63202 0.0369575 8.3464C0.12631 8.05549 0.36307 7.84921 0.648293 7.8069L7.33209 6.78608L10.3211 0.444295C10.4488 0.169255 10.7118 0 11.0001 0C11.2884 0 11.5514 0.169255 11.6791 0.444295L14.6681 6.78608L21.3514 7.8069C21.6366 7.84921 21.8739 8.05549 21.9627 8.3464C22.0521 8.63202 21.9779 8.94937 21.7709 9.16094L16.9353 14.0958L18.0766 21.0723C18.1251 21.3685 18.0085 21.67 17.7753 21.8498C17.542 22.0243 17.2336 22.0508 16.9777 21.908L11.0001 18.6181L5.02204 21.908C4.91148 21.9714 4.79033 21.9979 4.66968 21.9979Z"}})])
          )
        }
      }
    